/* ============
 * Register Index Page
 * ============
 *
 * Page where the user can register
 */

import authService from '@/services/auth';
import Vue from 'vue';

export default {
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password'));
      } else {
        if (this.form.passwordConfirmation !== '') {
          this.$refs.form.validateField('passwordConfirmation');
        }
        callback();
      }
    };

    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password again'));
      } else if (value !== this.form.password) {
        callback(new Error("Two inputs don't match!"));
      } else {
        callback();
      }
    };

    return {
      roles: [],
      form: {
        firstName: null,
        lastName: null,
        email: null,
        passwordConfirmation: null,
        password: null,
        roleId: null,
      },
      rules: {
        password: [{ validator: validatePass, trigger: 'blur' }],
        passwordConfirmation: [{ validator: validatePass2, trigger: 'blur' }],
      },
    };
  },

  mounted() {
    this.fetchRules();
  },

  methods: {
    onSubmit(form) {
      this.$refs.form.validate(valid => {
        if (valid) {
          authService.register(form);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    fetchRules() {
    Vue.$http
      .get('Roles')
      .then(response => {
        this.roles = response.data;
      })
      .catch(error => {
        console.log(error)
      });
    },
    navigate(data) {
      Vue.router.push(data);
    },
  },

  components: {
    VLayout: require('@/layouts/default/default.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/pages/user/new/index.js